import React, { useEffect } from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import PrivacyScreenComponent from '../components/layout/PrivacyScreenComponent';
import Fade from 'react-reveal/Fade';

const PrivacyScreen = () => {

  useEffect(() => {
    window.scrollTo(0,0)
  }, [])
  
  return (
    <>
        <Header />
          <Fade>
            <PrivacyScreenComponent />
          </Fade>
        <Footer />
    </>
  );
}

export default PrivacyScreen;